<div [formGroup]="form">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Choose cases to run</h4>
    </div>
    <div class="modal-body">
        <div class="col-sm-4 col-md-12">
            <div class="form-group">
                <label>Comment</label>
                <textarea class="form-control" rows="4" [ngModel]="comment" (ngModelChange)="commentChanged($event)" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <dx-data-grid biz-grid 
                                [selection]='{ mode: "multiple" }' 
                                [dataSource]='testCases' 
                                [bizSetColumnChooser]="true"
                                [bizSetAllowColumnReordering]="true" 
                                [bizSetSearchPanel]="true" 
                                [bizSetPager]="true" 
                                [bizSetPaging]="false"                            
                                [bizEditRowOnDoubleClick]="false"
                                [bizSetGroupPanel]="false"
                                (onSelectionChanged)='onSelectionChanged($event)'
                                (onEditorPreparing)='onEditorPreparing($event)'
                                bizRowsSelectedTemplate='rowsSelected'>
                                
                        <dxi-column dataField="Name" caption="Name" dataType="string" [allowFiltering]="true" [allowGrouping]="false">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dxi-column>
                        
                        <dxi-column dataField="Description" caption="Description" dataType="string" [allowFiltering]="true" [visible]="true"
                            [allowGrouping]="false">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dxi-column>
                        
                        <dxi-column dataField="PreRunValidationDescription" caption="Ready to run" dataType="string"
                            cellTemplate="preRunValidationDescriptionTemplate" [allowFiltering]="true" [allowGrouping]="false">
                        </dxi-column>

                        <dxi-column dataField="CreatedDate" caption="Created Date" dataType="Date" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="ModifiedDate" caption="Modified Date" dataType="Date" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="CreatedByName" caption="Created by" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="ModifiedByName" caption="Modified by" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="LastRunDate" caption="Last Run Date" dataType="Date" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="LastRunStatus" caption="Last Run Status" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="LastRunComment" caption="Last Run Comment" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="LastRunBy" caption="Last Run By" dataType="Date" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
                        <dxi-column dataField="NumberOfDocuments" caption="Number Of Documents" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
        
                        <div *dxTemplate="let data of 'rowsSelected'">
                            <span style="margin-right: 4em; text-wrap: nowrap;">Number of selected rows: {{ data.counter.selectedRows }}</span>
                        </div>

                        <div *dxTemplate="let cell of 'preRunValidationDescriptionTemplate'">
                            <span [style.color]="cell.data.PreRunValidationDescription === 'Ready' ? 'darkseagreen' : 'indianred'">
                                {{cell.data.PreRunValidationDescription}}
                            </span>
                        </div>
                    </dx-data-grid>
                </div>
            </div>
        </div>
        <br />
    </div> 
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="ok()" [disabled]="form.invalid">Ok</button>
        <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
    </div>
</div>